<template>
    <div
        key="icon"
        :style="{
            backgroundColor: color,
            padding: `${offset}px`
        }"
        class="widget-status-card-icon"
    >
        <redesign-base-icon
            :name="icon"
            :fill="color"
            :size="size"
            :color="iconColor"
        />
    </div>
</template>

<script setup lang="ts">
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'

withDefaults(
    defineProps<{
        icon: string,
        color?: string
        size?: number
        iconColor?: string
        offset?: number
    }>(), {
        color: '',
        size: 24,
        iconColor: 'white',
        offset: 6
    })
</script>
